import { IconProps } from "./";
import Icon from "./assets/doc_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Doc(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
